export class AliasesFeatureState {
  id: string;
}
